import React from "react";
import { Handshake, Map, Search } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const advantages = [{
  title: "Morsches Totholz",
  description: "Herabfallende Äste gefährden Personen und Sachwerte. Wir entfernen Totholz fachgerecht und sichern Ihren Baumbestand in Hamburg und Umgebung.",
  icon: Handshake
}, {
  title: "Störende Wurzeln",
  description: "Wurzeln heben Gehwege an oder schädigen Leitungen. Wir finden nachhaltige Lösungen, die sowohl den Baum als auch Ihre Infrastruktur schützen.",
  icon: Map
}, {
  title: "Bäume zu nah am Haus",
  description: "Äste am Dach oder an der Fassade können Schäden verursachen. Unser präziser Gebäudefreischnitt sorgt für den nötigen Sicherheitsabstand.",
  icon: Search
}];
export default function TheNeighborlyAdvantage() {
  return;
}